module.exports = __webpack_public_path__ + "static/media/count25Off_326.7b8b0940.png";